// Filters for the resident List table header drop-down filter menu
export const INSTALLATION = {
  complete: "Installation completed",
  incomplete: "Installation incomplete",
};

export const FILTERS = {
  all: "All residents",
  AT_RISK: "At risk residents",
  UNEXPECTED: "Unexpected residents",
  EXPECTED: "Expected residents",
  friends_and_family: "Assigned Friend/Family",
  no_friends_and_family: "Not assigned Friend/Family",
  ...INSTALLATION,
};

export const INSTALLER_FILTERS = {
  ...INSTALLATION,
};

export const INCOMPLETE_STATUSES = ["incomplete", "started", "failed"];
